import { useQuery } from '@apollo/client';
import { useMemo } from 'react';

import {
  GetHealthProfessionalItemDocument,
  HealthProfessionalItemDataFragment,
} from '../../types/api/graphql';

export function useHealthProfessionalItem(id: string | null | undefined) {
  const {
    data: healthProfessionalItemData,
    loading: healthProfessionalItemLoading,
  } = useQuery(GetHealthProfessionalItemDocument, {
    variables: {
      id: id ?? '',
    },
    skip: !id,
  });

  const data = useMemo(() => {
    if (healthProfessionalItemData?.healthProfessional) {
      return healthProfessionalItemData?.healthProfessional as HealthProfessionalItemDataFragment;
    }

    return undefined;
  }, [healthProfessionalItemData?.healthProfessional]);

  return {
    data,
    loading: healthProfessionalItemLoading,
  };
}
